
export default function BeforeAfter() {
  const comparisons = [
    {
      label: '실제 웨딩 촬영',
      badge: '기존 방식',
      cost: '50~180만원',
      costSub: '스튜디오·드레스·메이크업 포함',
      time: '촬영 준비 수개월',
      timeSub: '스튜디오 예약·드레스 피팅 등',
      result: '촬영 후 2~4주 후 수령',
      resultSub: '보정 작업 대기 필요',
      stress: '높은 스트레스',
      stressSub: '당일 날씨·컨디션 영향',
      icon: 'ri-camera-line',
      highlight: false,
    },
    {
      label: '봄날 AI 웨딩',
      badge: '추천',
      cost: '19,900원~',
      costSub: '최대 99% 비용 절감',
      time: '사진 2~3장 업로드',
      timeSub: '준비 시간 5분이면 충분',
      result: '당일 24시간 내 수령',
      resultSub: '즉시 다운로드 가능',
      stress: '스트레스 제로',
      stressSub: '집에서 편하게 완성',
      icon: 'ri-magic-line',
      highlight: true,
    },
  ];

  const merits = [
    { icon: 'ri-money-cny-circle-line', title: '비용 최대 99% 절감', desc: '50~180만원 → 19,900원부터' },
    { icon: 'ri-time-line', title: '당일 수령', desc: '신청 후 24시간 이내 고화질 사진 전달' },
    { icon: 'ri-emotion-happy-line', title: '스트레스 없는 촬영', desc: '날씨·컨디션 걱정 없이 집에서 완성' },
    { icon: 'ri-brush-line', title: '다양한 스타일 선택', desc: '클래식·모던·내추럴 등 6가지 스타일 제공' },
    { icon: 'ri-heart-2-line', title: '둘만의 특별한 사진', desc: '두 분의 얼굴을 학습해 자연스러운 투샷 완성' },
    { icon: 'ri-shield-check-line', title: '개인정보 완벽 보호', desc: '업로드 사진은 생성 완료 후 안전하게 삭제 처리' },
  ];

  return (
    <section className="py-28 bg-[#FDFAF6]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#C9A96E] text-xs tracking-[0.4em] uppercase mb-4 font-light">Why Bomnal</p>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-[#2D2D2D] mb-5">
            왜 봄날 AI를<br />
            <span className="italic">선택해야 할까요?</span>
          </h2>
          <p className="text-gray-500 text-sm font-light max-w-lg mx-auto leading-relaxed">
            실제 웨딩 촬영과 봄날 AI를 직접 비교해보세요. 차이가 명확합니다.
          </p>
        </div>

        {/* 비교 카드 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {comparisons.map(c => (
            <div
              key={c.label}
              className={`relative rounded-2xl p-10 transition-all duration-300 ${
                c.highlight
                  ? 'bg-[#2D2D2D] shadow-2xl ring-2 ring-[#C9A96E]'
                  : 'bg-white border border-gray-200'
              }`}
            >
              <div className="flex items-center justify-between mb-8">
                <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${c.highlight ? 'bg-[#C9A96E]' : 'bg-gray-100'}`}>
                  <i className={`${c.icon} text-2xl ${c.highlight ? 'text-white' : 'text-gray-400'}`}></i>
                </div>
                <span className={`px-4 py-1.5 rounded-full text-xs font-medium ${
                  c.highlight ? 'bg-[#C9A96E] text-white' : 'bg-gray-100 text-gray-500'
                }`}>
                  {c.badge}
                </span>
              </div>

              <h3 className={`font-serif text-2xl font-medium mb-8 ${c.highlight ? 'text-white' : 'text-gray-700'}`}>
                {c.label}
              </h3>

              <ul className="space-y-5">
                {[
                  { icon: 'ri-money-dollar-circle-line', label: '비용', value: c.cost, sub: c.costSub },
                  { icon: 'ri-time-line', label: '준비', value: c.time, sub: c.timeSub },
                  { icon: 'ri-image-line', label: '결과물', value: c.result, sub: c.resultSub },
                  { icon: 'ri-emotion-line', label: '편의성', value: c.stress, sub: c.stressSub },
                ].map(item => (
                  <li key={item.label} className="flex items-start gap-4">
                    <div className={`w-9 h-9 flex items-center justify-center rounded-full shrink-0 mt-0.5 ${c.highlight ? 'bg-white/10' : 'bg-gray-100'}`}>
                      <i className={`${item.icon} text-sm ${c.highlight ? 'text-[#C9A96E]' : 'text-gray-400'}`}></i>
                    </div>
                    <div>
                      <p className={`text-base font-semibold leading-tight ${c.highlight ? 'text-white' : 'text-gray-700'}`}>{item.value}</p>
                      <p className={`text-xs mt-0.5 font-light ${c.highlight ? 'text-white/50' : 'text-gray-400'}`}>{item.sub}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 절약 강조 배너 */}
        <div className="bg-gradient-to-r from-[#C9A96E]/15 to-[#E8D5B7]/25 rounded-2xl p-8 text-center border border-[#E8D5B7] mb-16">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase mb-3 font-light">절약 금액</p>
          <p className="text-5xl font-light text-[#2D2D2D] mb-3">
            <span className="font-bold text-[#C9A96E]">약 174만원</span> 절약
          </p>
          <p className="text-gray-500 text-sm font-light">
            실제 웨딩 촬영 평균 비용 180만원 대비 · 봄날 프리미엄 59,900원
          </p>
        </div>

        {/* 메리트 그리드 */}
        <div className="text-center mb-12">
          <p className="text-[#C9A96E] text-xs tracking-[0.4em] uppercase mb-4 font-light">Our Benefits</p>
          <h3 className="font-serif text-3xl md:text-4xl font-light text-[#2D2D2D] mb-4">
            봄날 AI만의 <span className="italic">특별한 장점</span>
          </h3>
          <p className="text-gray-500 text-sm font-light max-w-md mx-auto">
            단순한 비용 절감을 넘어, 더 나은 경험을 제공합니다.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {merits.map(m => (
            <div key={m.title} className="bg-white rounded-2xl p-7 border border-[#F0E8DC] hover:shadow-md hover:-translate-y-1 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#FDF5EA] mb-5">
                <i className={`${m.icon} text-xl text-[#C9A96E]`}></i>
              </div>
              <h4 className="font-serif text-base font-semibold text-[#2D2D2D] mb-2">{m.title}</h4>
              <p className="text-sm text-gray-500 font-light leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
